import {
    DELETEDEALERAGENT_SUCCESS,
    DELETEDEALERAGENT_FAILED,
    RESET_DELETEDEALERAGENT,
    LOADING_DELETEDEALERAGENT,
    NETWORK_ERROR_DELETEDEALERAGENT
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetDeleteDealerListForPartner = () => {
    return { type: RESET_DELETEDEALERAGENT };
};


const partnerDeleteDealerListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETEDEALERAGENT });
    await partnerServices
        .post("deleteDealer", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerDeleteDealerListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerDeleteDealerListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DELETEDEALERAGENT,
                payload: err
            });
        });
};


function partnerDeleteDealerListsuccess(data) {
    return {
        type: DELETEDEALERAGENT_SUCCESS,
        payload: data,
    };
}

function partnerDeleteDealerListFailed(data) {
    return {
        type: DELETEDEALERAGENT_FAILED,
        payload: data,
    };
}
export { resetDeleteDealerListForPartner, partnerDeleteDealerListReq }